<template>
  <div class="app-container" style="height:100%;">

    <myTableSearch
        ref="myTableSearchRef"
        :isOperate="true"
        :operateWidth="120"
        :titleName="$route.meta.title"
        :queryFn="getList"
        :formData="formData"
        :tableLabel="tableLabel"
        @recombinationData="recombinationData"
    >
      <template slot="tool">
        <div class="flex flex-x">
          <div class="fillBtn" @click="handleAdd" v-hasPermi="['sys:role:add']">
            <img src="@/assets/images/gzq/icon-add.png" alt="" />
            <span>新增数据</span>
          </div>
        </div>
      </template>
      <template #createTime="scope">
        <span>{{ parseTime(scope.row.createTime) }}</span>
      </template>
      <template slot="operate" slot-scope="scope">
        <div class="operateBtn flex">
          <div class="itemBtn" @click="handleUpdate(scope.row)" v-hasPermi="['sys:role:edit']">修改</div>
          <div class="itemBtn ml-1" @click="handleDelete(scope.row)" v-hasPermi="['sys:role:remove']">删除</div>
        </div>
      </template>
    </myTableSearch>

    <!-- 添加或修改角色配置对话框 -->f
    <myDialog :isDialog="open" :title="title" :width="'600px'" @handleClose="cancel">
      <template slot="content">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="角色名称" prop="roleName">
            <el-input v-model="form.roleName" placeholder="请输入角色名称"/>
          </el-form-item>
          <el-form-item label="权限字符" prop="roleKey">
            <el-input v-model="form.roleKey" placeholder="请输入权限字符"/>
          </el-form-item>
          <el-form-item label="角色顺序" prop="roleSort">
            <el-input-number v-model="form.sort" controls-position="right" :min="0"/>
          </el-form-item>
          <el-form-item label="菜单权限">
            <el-checkbox v-model="menuExpand" @change="handleCheckedTreeExpand($event, 'menu')">展开/折叠</el-checkbox>
            <el-checkbox v-model="menuNodeAll" @change="handleCheckedTreeNodeAll($event, 'menu')">全选/全不选</el-checkbox>
            <el-checkbox v-model="form.menuCheckStrictly" @change="handleCheckedTreeConnect($event, 'menu')">父子联动
            </el-checkbox>
            <el-tree
                class="tree-border"
                :data="menuOptions"
                show-checkbox
                ref="menu"
                node-key="id"
                :check-strictly="!form.menuCheckStrictly"
                empty-text="加载中，请稍后"
                :props="defaultProps"
            ></el-tree>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.remark" type="textarea" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template slot="footer">
        <div class="formBtnBox">
          <div class="saveBtn" @click="submitForm">确 定</div>
          <div class="editBtn ml-4"  @click="cancel">取 消</div>
        </div>
      </template>
    </myDialog>

    <!-- 分配角色数据权限对话框 -->
    <myDialog :isDialog="openDataScope" :title="title" :width="'600px'" @handleClose="cancelDataScope">
      <template slot="content">
        <el-form :model="form" label-width="80px">
          <el-form-item label="角色名称">
            <el-input v-model="form.roleName" :disabled="true"/>
          </el-form-item>
          <el-form-item label="权限字符">
            <el-input v-model="form.roleKey" :disabled="true"/>
          </el-form-item>
          <el-form-item label="权限范围">
            <el-select v-model="form.dataScope">
              <el-option
                  v-for="item in dataScopeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template slot="footer">
        <div class="formBtnBox">
          <div class="saveBtn" @click="submitDataScope">确 定</div>
          <div class="editBtn ml-4"  @click="cancelDataScope">取 消</div>
        </div>
      </template>
    </myDialog>
  </div>
</template>

<script>
import {rolePage, roleDetail, roleDelete, roleAdd, roleUpdate, dataScope} from "@/api/sys/role";
import {treeSelect as menuTreeSelect, treeSelectMenuByRole} from "@/api/sys/menu";

export default {
  name: "Role",
  data() {
    return {
      formData: [
        {
          label: "角色名称",
          type: "input",
          key: "roleName",
        },
        {
          label: "权限字符",
          type: "input",
          key: "roleKey",
        },
      ],
      tableLabel: [
        {
          prop: "roleName",
          label: "角色名称",
        },
        {
          prop: "roleKey",
          label: "权限字符",
        },
        {
          prop: "sort",
          label: "显示顺序",
        },
        {
          prop: "createTime",
          label: "创建时间",
        },
      ],
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 角色表格数据
      roleList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否显示弹出层（数据权限）
      openDataScope: false,
      menuExpand: false,
      menuNodeAll: false,
      // 日期范围
      dateRange: [],
      // 数据范围选项
      dataScopeOptions: [
        {
          value: "1",
          label: "全部数据权限"
        },
        {
          value: "2",
          label: "本部门及以下数据权限"
        },
        {
          value: "3",
          label: "本部门数据权限"
        },
        {
          value: "4",
          label: "仅本人数据权限"
        }
      ],
      // 菜单列表
      menuOptions: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        query: {
          roleName: undefined,
          roleKey: undefined,
          status: undefined
        }
      },
      // 表单参数
      form: {},
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 表单校验
      rules: {
        roleName: [
          {required: true, message: "角色名称不能为空", trigger: "blur"}
        ],
        roleKey: [
          {required: true, message: "权限字符不能为空", trigger: "blur"}
        ],
        sort: [
          {required: true, message: "角色顺序不能为空", trigger: "blur"}
        ]
      }
    };
  },
  // created() {
  //   this.getList();
  // },
  methods: {
    getList(e) {
      return rolePage(e)
    },
    //格式化搜索字段
    recombinationData(param, callback) {
      param = {
        ...param,
        params:{}
      };
      callback({ ...param });
    },
    /** 查询角色列表 */
    // getList() {
    //   this.loading = true;
    //   rolePage(this.addDateRange(this.queryParams, this.dateRange)).then(
    //       response => {
    //         this.roleList = response.data.rows;
    //         this.total = response.data.total;
    //         this.loading = false;
    //       }
    //   );
    // },
    /** 查询菜单树结构 */
    getMenuTreeSelect() {
      menuTreeSelect({}).then(response => {
        this.menuOptions = response.data;
      });
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys() {
      // 目前被选中的菜单节点
      let checkedKeys = this.$refs.menu.getCheckedKeys();
      // 半选中的菜单节点
      let halfCheckedKeys = this.$refs.menu.getHalfCheckedKeys();
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    },
    /** 根据角色ID查询菜单树结构 */
    getRoleMenuTreeSelect(roleId) {
      return treeSelectMenuByRole(roleId).then(response => {
        this.menuOptions = response.menus;
        return response;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 取消按钮（数据权限）
    cancelDataScope() {
      this.openDataScope = false;
      this.reset();
    },
    // 表单重置
    reset() {
      if (this.$refs.menu !== undefined) {
        this.$refs.menu.setCheckedKeys([]);
      }
      this.menuExpand = false,
          this.menuNodeAll = false,
          this.form = {
            menuCheckStrictly: true,
            id: undefined,
            roleName: undefined,
            roleKey: undefined,
            sort: 0,
            menuIds: [],
            remark: undefined
          };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    // 树权限（展开/折叠）
    handleCheckedTreeExpand(value, type) {
      if (type === 'menu') {
        let treeList = this.menuOptions;
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.menu.store.nodesMap[treeList[i].id].expanded = value;
        }
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value, type) {
      if (type === 'menu') {
        this.$refs.menu.setCheckedNodes(value ? this.menuOptions : []);
      }
    },
    // 树权限（父子联动）
    handleCheckedTreeConnect(value, type) {
      if (type === 'menu') {
        this.form.menuCheckStrictly = value ? true : false;
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.getMenuTreeSelect();
      this.open = true;
      this.title = "添加角色";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const roleId = row.id;
      const roleMenu = this.getRoleMenuTreeSelect(roleId);
      roleDetail(roleId).then(response => {
        this.form = response.data;
        this.open = true;
        this.$nextTick(() => {
          roleMenu.then(res => {
            this.$refs.menu.setCheckedKeys(res.checkedKeys);
          });
        });
        this.title = "修改角色";
      });
    },
    /** 分配数据权限操作 */
    handleDataScope(row) {
      this.reset();
      roleDetail(row.id).then(response => {
        this.form = response.data;
        this.openDataScope = true;
        this.title = "分配数据权限";
      });
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id !== undefined) {
            this.form.menuIds = this.getMenuAllCheckedKeys();
            roleUpdate(this.form).then(() => {
              this.msgSuccess("修改成功");
              this.open = false;
              // this.getList();
              this.$refs.myTableSearchRef.searchReset();
            });
          } else {
            this.form.menuIds = this.getMenuAllCheckedKeys();
            roleAdd(this.form).then(() => {
              this.msgSuccess("新增成功");
              this.open = false;
              // this.getList();
              this.$refs.myTableSearchRef.searchReset();
            });
          }
        }
      });
    },
    /** 提交按钮（数据权限） */
    submitDataScope: function () {
      if (this.form.id !== undefined) {
        dataScope(this.form).then(() => {
          this.msgSuccess("修改成功");
          this.openDataScope = false;
          // this.getList();
          this.$refs.myTableSearchRef.searchReset();
        });
      }
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm('是否确认删除角色为"' + row.roleName + '"的数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return roleDelete(row.id);
      }).then(() => {
        // this.getList();
        this.$refs.myTableSearchRef.searchReset();
        this.msgSuccess("删除成功");
      })
    },
  }
};
</script>

<style scoped lang="scss">
/deep/.el-checkbox__label{
  // color: #0db3ed !important;
}
.el-tree{
  // background: #08141e;
}
/deep/.el-tree .el-tree-node__content{
  /* padding: 0!important; */
  line-height: 1!important;
}
/deep/.el-dialog__body{
  padding: 30px 50px!important;
  max-height: 600px;
  overflow-y: scroll;
}
/* 修改垂直滚动条 */
/deep/::-webkit-scrollbar {
  width: 3px; /* 修改宽度 */
}
/deep/.el-textarea__inner{
  // background:#132C42 ;
  // color: #0db3ed !important;
  // border: none;
}
</style>
